const TokenInvalidFlag=0;
export default
{
  TokenInvalidFlag,//token无效标记

}

